export enum INVOICE_TYPE {
	RECEIPT_INVOICE = 'FR',
	COMMON_INVOICE = 'FT',
}
